'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SamlName$() {
  this.cbP = null;
  this.cbQ = false;
  this.cbR = null;
  this.cbS = false;
}
export { $c_Lpresto_types$SamlName$ as $c_Lpresto_types$SamlName$ };
$p = $c_Lpresto_types$SamlName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SamlName$;
/** @constructor */
function $h_Lpresto_types$SamlName$() {
}
export { $h_Lpresto_types$SamlName$ as $h_Lpresto_types$SamlName$ };
$h_Lpresto_types$SamlName$.prototype = $p;
$p.cIQ = (function() {
  if ((!this.cbQ)) {
    this.cbP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.cbQ = true;
  }
  return this.cbP;
});
$p.cJQ = (function() {
  if ((!this.cbS)) {
    this.cbR = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.cbS = true;
  }
  return this.cbR;
});
var $d_Lpresto_types$SamlName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SamlName$, "presto.types$SamlName$", ({
  a1B: 1,
  D: 1
}));
export { $d_Lpresto_types$SamlName$ as $d_Lpresto_types$SamlName$ };
var $n_Lpresto_types$SamlName$;
function $m_Lpresto_types$SamlName$() {
  if ((!$n_Lpresto_types$SamlName$)) {
    $n_Lpresto_types$SamlName$ = new $c_Lpresto_types$SamlName$();
  }
  return $n_Lpresto_types$SamlName$;
}
export { $m_Lpresto_types$SamlName$ as $m_Lpresto_types$SamlName$ };
//# sourceMappingURL=presto.types$-Saml-Name$.js.map
